import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CropImageService } from './crop-image.service';
import { CropImageDialogComponent } from './crop-image-dialog/crop-image-dialog.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, FiLoadingModule, ImageCropperComponent, MatButtonModule],
    declarations: [CropImageDialogComponent],
    providers: [CropImageService],
})
export class CropImageModule {}
